module.exports = __webpack_public_path__ + "static/assets/42f8d982c31a63d2a48ae6b753493aec.png";